<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="custom-session">
        <div class="row">
          <div class="col-md-12">
            <session-statistics />
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-3 text-end">
            <button class="btn btn-link" @click="navigate('previous')">
              <i class="far fa-arrow-alt-circle-left me-1"></i>Previous Session
            </button>
          </div>
          <div class="col-md-3 text-start">
            <button class="btn btn-link" @click="navigate('next')">
              Next Session<i class="far fa-arrow-alt-circle-right ms-1"></i>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h6 class="text-center">
              Heart Rate
              <button
                class="btn btn-link custom-eye"
                @click="viewHeartSamples"
                title="heart rate sample data"
              >
                <i class="fas fa-eye"></i>
              </button>
            </h6>
            <heartrate-chart />
          </div>
          <div class="col-md-6 mt-1">
            <h6 class="text-center">Zone Distribution</h6>
            <zone-dist-chart />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import SessionStatistics from './statistics'
import HeartrateChart from './heartrate-chart'
import ZoneDistChart from './zonedist-chart'
export default {
  name: 'session-dialog',
  components: {
    ZDialog,
    SessionStatistics,
    HeartrateChart,
    ZoneDistChart,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-xl',
    }
  },
  emits: ['close', 'saved', 'showSamples'],
  computed: {
    ...mapGetters('usercardio', ['member', 'memberSession']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Workout Session'
      if (this.member) {
        _title += ` for ${this.member.firstName} ${this.member.lastName}`
      }
      console.log('Member Info', this.member)
      return _title
    },
  },
  methods: {
    ...mapActions('usercardio', [
      'getMemberSessionHeartRates',
      'getMemberSessionDetail',
    ]),
    close() {
      this.currentTab = 'Basic'
      this.$emit('close')
    },
    async navigate(direction) {
      console.log('Navigate', direction)
      let data = {
        id: parseInt(this.memberSession.userid),
        session:
          direction === 'previous'
            ? parseInt(this.memberSession.previousSession.id)
            : parseInt(this.memberSession.nextSession.id),
      }
      await this.getMemberSessionDetail(data)
    },
    async viewHeartSamples() {
      console.log('View Heart Samples')
      let data = {
        id: this.memberSession.userid,
        session: this.memberSession.sessionid,
      }
      await this.getMemberSessionHeartRates(data)
      this.$emit('showSamples')
    },
  },
}
</script>
<style scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-eye {
  position: relative;
  top: 0;
  font-size: 1.1em;
}
.custom-session {
  max-height: 560px;
}
</style>
